import React from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { SystemAlert } from "@components/shared";

export default function ContestAlerts({ contestId, setShowWizard }) {
  const { data: alerts } = useQuery({
    initialData: [],
    queryKey: [`contests${contestId}ConfigAlerts`],
    queryFn: async () =>
      axios
        .post(`/contests/${contestId}/data-grabber/`, {
          context: `config_alerts`,
          contest_id: contestId,
        })
        .then(({ data }) => {
          return data.response;
        })
        .catch((err) => {
          throw err;
        }),
  });

  const arr = alerts
    .filter((f) => f.trigger)
    .map((m) => ({
      ...m,
      level: m.color === "yellow" ? 1 : 2,
      path: m.alt_path
        ? `/${m.alt_path}`
        : `/${m.variety}/${contestId}${getConfigPathname(m.context)}`,
    }))
    .sort((a, b) => a.level - b.level);

  if (!arr.length) return null;

  return (
    <>
      {arr.map((alert, i) => (
        <SystemAlert
          alert={alert}
          key={i}
          onClick={() => {
            setShowWizard(false);
          }}
        />
      ))}
    </>
  );
}

function getConfigPathname(context) {
  switch (context) {
    case "assets":
      return "/assets";
    case "prizes":
      return "/prizes";
    default:
      return "";
  }
}
